import Layout from '@/layout'

const workOrderManagerRouter = {
  path: '/work_order',
  component: Layout,
  redirect: '/work_order/work_order_list',
  name: 'work_order',
  meta: {
    title: '工单管理',
    icon: 'el-icon-s-order',
    roles: ['sls_workorder']
  },
  children: [
    {
      path: 'work_order_list',
      component: () => import('@/views/work-order-manager/work-order-list'),
      name: 'work_order_list',
      meta: { title: '工单列表', roles: ['sls_workorder_list'] }
    },
    {
      path: 'supplementary_work_order',
      component: () => import('@/views/work-order-manager/supplementary-work-order'),
      name: 'SupplementaryWorkOrder',
      meta: { title: '补录工单', roles: ['sls_workorder_supplementary'] }
    },
    {
      path: 'clientFeedback',
      component: () => import('@/views/work-order-manager/feedback'),
      name: 'clientFeedback',
      meta: { title: '客户反馈', roles: ['sls_workorder_feedback'] }
    },
    {
      path: 'work_order_adjust',
      component: () => import('@/views/work-order-manager/work-order-update'),
      name: 'workOrderAdjust',
      hidden: true,
      meta: { title: '编辑工单', roles: ['sls_workorder_list'] }
    }
  ]
}
export default workOrderManagerRouter
